export default __webpack_public_path__ + "static/media/remix-studio-preview.486a438b.svg";